export const filterOperators = {
  EQ: 'EQ',
  NEQ: 'NEQ',
  GT: 'GT',
  GTE: 'GTE',
  LT: 'LT',
  LTE: 'LTE',
  LIKE: 'LIKE',
  ILIKE: 'ILIKE',
  NOT_LIKE: 'NOT_LIKE',
  IN: 'IN',
  NOT_IN: 'NOT_IN',
  BETWEEN: 'BETWEEN',
  NOT_BETWEEN: 'NOT_BETWEEN',
  IS_NULL: 'IS_NULL',
  IS_NOT_NULL: 'IS_NOT_NULL',
};

export const filterTypes = {
  TEXT: 'text',
  DATERANGE: 'daterange',
  TIMEZONE: 'timezone',
  DROPDOWN: 'dropdown',
  INTRANGE: 'intrange',
  USER: 'user',
  COMPANY: 'company',
  ACTIVITY_TYPE: 'activityType',
  LIST_ITEM: 'listItem',
  BOOLEAN_LIST: 'booleanList',
  PROVIDER: 'provider',
  FACILITY: 'facility',
  CASE: 'case',
  CPT: 'cpt',

  TEXT_DROPDOWN: 'DROPDOWN',
  TEXT_DROPDOWN_MULTIPLE: 'DROPDOWN_MULTIPLE',
  INT: 'INT',
  INT_RANGE: 'INT_RANGE',
  INT_RANGE_COST: 'INT_RANGE_COST',
  INT_DROPDOWN: 'INT_DROPDOWN',
  BOOLEAN_DROPDOWN: 'BOOLEAN_DROPDOWN',
  DATE: 'DATE',
  DATE_RANGE: 'DATE_RANGE',
  DATETIME_RANGE: 'DATETIME_RANGE',
  POSTAL: 'POSTAL',
};

export const filterRelations = {
  HAS_ADDRESSES: 'hasAddresses',
  HAS_CONTACTS: 'hasContacts',
  HAS_ROLES: 'hasRoles',
  HAS_CLIENT: 'hasClient',
  HAS_COMPANY: 'hasCompany',
  HAS_STAFF: 'hasStaff',
  HAS_STAFF_USER: 'hasStaffUser',
  HAS_INTERNAL_OVERSIGHT: 'hasInternalOversight',
  HAS_LOCATION: 'hasLocation',
  HAS_LIST_ITEMS: 'hasListItems',
  HAS_LIST_TYPE: 'hasListType',
  HAS_CPT: 'hasCpt',
  HAS_PROVIDER: 'hasProvider',
  HAS_PROVIDER_CONTACTS: 'hasProviderContacts',
  HAS_FACILITY: 'hasFacility',
  HAS_CASE: 'hasCase',
  HAS_OTR: 'hasOtr',
  HAS_RATE: 'hasRate',
  HAS_HEALTH_PLAN: 'hasHealthPlan',
  HAS_CONTRACTS: 'hasContracts',
  HAS_AUTHORIZATION: 'hasAuthorization',
  HAS_AUTHORIZATIONS: 'hasAuthorizations',
  HAS_RATES_CPTS: 'hasRatesCpts',
  HAS_ACTIVITY_TYPE: 'hasActivityType',
  HAS_CASE_CLAIM: 'hasCaseClaim',
  HAS_CASE_CLIENT: 'hasCaseClient',
  HAS_CLIENT_COMPANY: 'hasClientCompany',
  HAS_CLIENT_COMPANY_CONTRACT: 'hasClientCompanyContract',
  HAS_CREDENTIAL: 'hasCredentials',
  HAS_CASE_COMPANY: 'hasCaseCompany',
  HAS_CASE_COMPANY_CONTRACTS: 'hasCaseCompanyContracts',
  HAS_CASE_CLIENT_LOCATION: 'hasCaseClientLocation',
  HAS_CASE_CLIENT_OCCUPATION: 'hasCaseClientOccupation',
  HAS_CASE_CLIENT_HEALTH_PLAN: 'hasCaseClientHealthPlan',
  HAS_AUTHORIZATION_CASE: 'hasAuthorizationCase',
  HAS_AUTHORIZATION_PROVIDER: 'hasAuthorizationProvider',
  HAS_AUTHORIZATION_FACILITY: 'hasAuthorizationFacility',
  HAS_AUTHORIZATION_CASE_COMPANY: 'hasAuthorizationCaseCompany',
  HAS_AUTHORIZATION_CASE_CLIENT: 'hasAuthorizationCaseClient',
  HAS_USER: 'hasUser',
  POSTAL_RADIUS: 'postalRadius',
};

export const filterScopes = {
  POSTAL_RADIUS: 'postalRadius',
};
